// extracted by mini-css-extract-plugin
export default {"Settings-saved-errorMessage":"Settings_Settings-saved-errorMessage__xGhbq"};